import * as position from 'common/utils/elementPosition';
import createScrollableElements from './components/scrollable';

// -----------------------------------------------------------------------------
// Sticky top bar
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    const stickies = document.querySelectorAll('[data-sticky-top]');

    for (const sticky of stickies) {
        document.addEventListener('scroll', () => {
            let top = position.distanceFromTop(sticky);
            let isActive = sticky.hasAttribute('data-sticky-top-active');

            if (top <= 0 && !isActive) {
                let clone = sticky.cloneNode(true);
                clone.setAttribute('data-sticky-top-clone', true);
                document.body.appendChild(clone);
                sticky.setAttribute('data-sticky-top-active', true);
            } else if (top > 0 && isActive) {
                let clone = document.querySelector('[data-sticky-top-clone]');
                document.body.removeChild(clone);
                sticky.removeAttribute('data-sticky-top-active');
            }
        });
    }
});

// -----------------------------------------------------------------------------
// Hide scrollbars on horizontal scroll components
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    createScrollableElements();
});



// WEBPACK FOOTER //
// ./js/marketing/howItWorks.jsx